// extracted by mini-css-extract-plugin
module.exports = {"user-list":"UserList_user-list__6ivLC","user-list-item":"UserList_user-list-item__2GmC4"};